/**
 * Infinite scroll for Impulse collection pages
 * Place this file at: assets/infinite-scroll.js
 * Loaded from: sections/main-collection.liquid
 */
(function () {
  var THRESHOLD_PX = 600; // start loading this many px before pagination scrolls into view
  var loading = false;
  var observer = null;
  var contentObserver = null;

  injectStyles();

  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = [
      // Collapse pagination visually but keep it in the layout flow —
      // IntersectionObserver needs a real bounding box, so display:none
      // would stop it from ever firing.
      '#CollectionAjaxContent .pagination {',
      '  height: 0;',
      '  margin: 0;',
      '  padding: 0;',
      '  border: 0;',
      '  overflow: hidden;',
      '}',

      '.infinite-scroll__loader {',
      '  width: 100%;',
      '  max-width: 240px;',
      '  height: 3px;',
      '  margin: 40px auto;',
      '  background: rgba(0, 0, 0, 0.08);',
      '  position: relative;',
      '  overflow: hidden;',
      '  border-radius: 3px;',
      '  opacity: 0;',
      '  transition: opacity 0.2s ease;',
      '}',

      '.infinite-scroll__loader--visible {',
      '  opacity: 1;',
      '}',

      '.infinite-scroll__loader-bar {',
      '  position: absolute;',
      '  top: 0;',
      '  left: 0;',
      '  height: 100%;',
      '  width: 40%;',
      '  background: currentColor;',
      '  animation: infiniteScrollLoading 1.1s ease-in-out infinite;',
      '}',

      '@keyframes infiniteScrollLoading {',
      '  0% { left: -40%; }',
      '  100% { left: 100%; }',
      '}',

      '.infinite-scroll__end {',
      '  text-align: center;',
      '  margin: 40px auto;',
      '  opacity: 0.6;',
      '  font-size: 0.9em;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function getElements() {
    return {
      content: document.getElementById('CollectionAjaxContent'),
      grid: document.getElementById('ProductGrid'),
      pagination: document.querySelector('#CollectionAjaxContent .pagination')
    };
  }

  function getOrCreateLoader() {
    var els = getElements();
    var loader = els.content.querySelector('.infinite-scroll__loader');

    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'infinite-scroll__loader';
      loader.innerHTML = '<div class="infinite-scroll__loader-bar"></div>';
      els.pagination.insertAdjacentElement('afterend', loader);
    }

    return loader;
  }

  function showLoader() {
    var loader = getOrCreateLoader();
    loader.classList.add('infinite-scroll__loader--visible');
  }

  function hideLoader() {
    var els = getElements();
    var loader = els.content.querySelector('.infinite-scroll__loader');
    if (loader) {
      loader.classList.remove('infinite-scroll__loader--visible');
    }
  }

  function showEndMessage() {
    var els = getElements();
    var existing = els.content.querySelector('.infinite-scroll__end');
    if (existing) return;

    var end = document.createElement('div');
    end.className = 'infinite-scroll__end';
    end.textContent = "You've seen it all!";
    els.grid.insertAdjacentElement('afterend', end);
  }

  function initInfiniteScroll() {
    var els = getElements();
    if (!els.grid || !els.pagination) return;

    var nextLink = els.pagination.querySelector('.next a');
    if (observer) observer.disconnect();

    if (!nextLink) {
      showEndMessage();
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !loading) {
          loadNextPage(nextLink.href);
        }
      });
    }, { rootMargin: THRESHOLD_PX + 'px' });

    observer.observe(els.pagination);
  }

  function loadNextPage(url) {
    loading = true;
    showLoader();

    var els = getElements();
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=ajax';

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('ProductGrid');
        var newPagination = doc.querySelector('#CollectionAjaxContent .pagination');

        // Temporarily stop watching content mutations while we make our own edits,
        // so we don't trigger a feedback loop through the content MutationObserver
        if (contentObserver) contentObserver.disconnect();

        if (newGrid) {
          while (newGrid.firstChild) {
            els.grid.appendChild(newGrid.firstChild);
          }
        }

        hideLoader();
        els.pagination.remove();

        var loaderEl = els.content.querySelector('.infinite-scroll__loader');

        if (newPagination) {
          if (loaderEl) {
            loaderEl.insertAdjacentElement('beforebegin', newPagination);
          } else {
            els.content.querySelector('.collection-grid__wrapper').appendChild(newPagination);
          }
        }

        // Re-run Impulse's own post-injection hook. This forces AOS to rescan
        // (AOS is initialized with disableMutationObserver: true, so it never
        // notices new nodes on its own) and re-inits quick shop / reviews.
        if (window.theme && typeof theme.reinitProductGridItem === 'function') {
          theme.reinitProductGridItem();
        }

        loading = false;
        initInfiniteScroll(); // rebind observer to the freshly appended pagination (or show end message)
        watchContentReplacement(); // resume watching for filter/sort re-renders
        document.dispatchEvent(new CustomEvent('infinite-scroll:loaded'));
      })
      .catch(function () {
        hideLoader();
        loading = false;
      });
  }

  // Impulse's filter/sort JS (theme.Collection) replaces the entire innerHTML
  // of #CollectionAjaxContent via its AjaxRenderer, with no custom event fired
  // that we can hook into cleanly. Watching for childList changes on that
  // container lets us detect a full re-render and rebind infinite scroll to
  // the new pagination element, regardless of what triggered the change.
  function watchContentReplacement() {
    var els = getElements();
    if (!els.content) return;

    if (contentObserver) contentObserver.disconnect();

    contentObserver = new MutationObserver(function () {
      clearTimeout(watchContentReplacement._t);
      watchContentReplacement._t = setTimeout(function () {
        initInfiniteScroll();
      }, 50);
    });

    contentObserver.observe(els.content, { childList: true, subtree: false });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initInfiniteScroll();
    watchContentReplacement();
  });
})();